export async function getBearerToken() {
  try {
    let token = localStorage.getItem('access_token');

    if (!token) {
      throw new Error('Access token is missing or invalid');
    }
    return `${token}`;
  } catch (error) {
    throw new Error(`Failed to get access token: ${error.message}`);
  }
}

export function isAuthenticated() {
  return !!localStorage.getItem('access_token');
}

export function logout() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('kinship_web_profile');
}
